<template>
  <div>
    <!--搜索-->
    <div class="search-wrapper">
      <el-form :inline="true" :model="searchForm" size="mini" :rules="rules" ref="searchForm">
        <div class="search-row">
          <el-form-item label="导入日期:">
            <el-date-picker
              v-model="searchForm.startDate"
              type="date"
              :picker-options="startDatePicker"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            至
            <el-date-picker
              v-model="searchForm.endDate"
              type="date"
              :picker-options="endDatePicker"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="float: right;">
            <el-button size="small" class="green-btn" @click="onSearch">搜索</el-button>
            <el-button size="small" class="orange-btn" @click="resetForm">重置</el-button>
            <el-button size="small" class="green-btn" @click="canclePage">返回</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!--列表-->
    <el-container class="list-wrapper">
      <el-header height="auto" style="padding: 10px 10px 0;">
        <el-button
          type="primary"
          icon="iconfont"
          size="small"
          class="green-btn"
          @click="showExport"
        >批量导入
        </el-button>
        <el-button
          type="primary"
          icon="iconfont"
          size="small"
          class="green-btn"
          @click="downloadTemplate"
        >下载模板
        </el-button>
      </el-header>
      <el-main class="table-wrap">
        <el-table
          border 
          v-loading="loading"
          @select="serlectRow"
          :data="tableData.list"
          :header-cell-style="{backgroundColor: '#F4F8FB'}"
          :height="tableHeight"
          style="width: 100%"
        >
          <el-table-column prop="fileName" label="文件名">
            <template slot-scope="scope">
              <a href="javascript:void(0);"
                 class="buttonText" @click="downloadFj(scope.row.fileMd5,scope.row.fileName)">{{scope.row.fileName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="createdBy" label="导入用户"></el-table-column>
          <el-table-column prop="creationDate" label="导入时间"></el-table-column>
          <el-table-column prop="parseStatusName" label="导入结果"></el-table-column>
          <el-table-column label="失败原因">
            <template slot-scope="scope">
              <a href="javascript:void(0);"
                 class="buttonText"
                 v-if="scope.row.parseResult"
                 @click="downloadFail(scope.row.id, scope.row.fileName)">下载</a>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="64px" style="text-align: right;padding-top: 15px;">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <el-dialog :title="titleName" width="60%;" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div slot="footer" class="dialog-footer">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" :inline="true">
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="附件" prop="goodsCode" label-width="40px">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="limit"
                  :action="uploadUrl"
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <el-button style="margin-left: 10px;"
                             v-loading.fullscreen.lock="fjLoading"
                             element-loading-text="数据导入中"
                             element-loading-spinner="el-icon-loading"
                             element-loading-background="rgba(0, 0, 0, 0.8)"
                             size="small" type="success" @click="submitUpload">上传
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button @click="cancel" size="medium">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import pagePathMixin from '@/utils/page-path-mixin'
  import {getToken} from '@/utils/auth'
  import axios from '@/utils/axiosInstance';
  // 注册中心名称
  const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
  export default {
    name: 'ImportExcel',
    mixins: [pagePathMixin],
    data() {
      return {
        titleName: '',
        headers: {
          'Authorization': getToken()
        },
        uploadUrl: '/qu-live-manage/file/upload?fileType=' + this.$route.query.fileType,
        limit: 1,
        fileList: [],
        searchForm: {
          filterData: {}
        },
        rules: {},
        requestParam: {},
        dialogFormVisible: false,
        tableHeight: null,
        tableData: {
          list: [],
          pageNum: 1,
          pageSize: 30,
          total: 0
        },
        model: [],
        maxHeight: 'auto',
        /*
        fileTypeObj: {
          '10': 'SKU导入',
          '11': '商品上市时间',
          '12': '商品发货周期',
          '13': '商品销售价',
          '14': '商品采购价',
          '15': '商品清仓销售状态',
          '16': '商品店铺定位',
          '17': '商品品类风格',
          '18': 'SPU导入',
          '21': '产品属性',
          '22': '产品清仓信息',
          '23': '产品零售指导价',
          '24': '产品上市时间'
        },
        */
        loading: false,
        endDatePicker: this.processDate(),
        startDatePicker: this.beginDate(),
        fjLoading: false
      };
    },
    computed: {},
    methods: {
      serlectRow(i, v) {
        this.model = i;
      },
      canclePage() {
        this.$router.go(-1)
      },
      downloadFj(fileMd5, fileName) {
        axios.get(`${apiName}/file/download/` + fileMd5, {responseType: 'blob'}).then(function (response) {
          const link = document.createElement('a')
          let blob = new Blob([response], {type: 'application/vnd.ms-excel'})
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = fileName // 下载的文件名
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        });
      },
      downloadFail(id, fileName) {
        axios.get(`${apiName}/file/download/fail/` + id, {responseType: 'blob'}).then(function (response) {
          const link = document.createElement('a')
          let blob = new Blob([response])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = '失败信息_' + fileName // 下载的文件名
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        });
      },
      downloadTxt(row) {
        this.$q.goods.downloadTxt({params: {id: row.id}}).then((res) => {
          const link = document.createElement('a')
          let blob = new Blob([res])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = row.fileName.substring(0, row.fileName.lastIndexOf('.')) + '.txt' // 下载的文件名
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        });
      },
      downloadTemplate() {
        let fileName = this.$route.query.fileName;
        if (!fileName) {
          this.$message.error('该菜单没有导入模板，请联系管理员！');
          return;
        }
        axios.get(`${apiName}/file/downloadTemplate?fileName=` + encodeURI(encodeURI(fileName)), {responseType: 'blob'}).then(function (response) {
          const link = document.createElement('a')
          let blob = new Blob([response], {type: 'application/vnd.ms-excel'})
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = fileName // 下载的文件名
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        });
      },
      showExport() {
        this.fileList = [];
        this.dialogFormVisible = true;
        let filename = this.$route.query.fileName;
        filename = filename.substring(0, filename.lastIndexOf('.'))
        this.titleName = filename + '批量维护';
      },
      cancel() {
        this.dialogFormVisible = false;
      },
      onSearch() {
        this.loading = true;
        let param = {
          pageNum: this.tableData.pageNum,
          pageSize: this.tableData.pageSize,
          filterData: {
            startDate: this.searchForm.startDate,
            endDate: this.searchForm.endDate,
            fileType: this.$route.query.fileType
          }
        }
        this.$q.goods.fileListPage({data: JSON.stringify(param)}).then((res) => {
          this.tableData = res.data;
          this.loading = false;
        });
      },
      initSearchForm() {
        this.searchForm = {
          filterData: {},
          startDate: null,
          endDate: null
        }
      },
      resetForm() {
        this.initSearchForm();
      },
      onSizeChange(pageSize) {
        this.tableData.pageSize = pageSize;
        this.tableData.pageNum = 1;
        this.onSearch();
      },
      onCurrentChange(pageNum) {
        this.tableData.pageNum = pageNum;
        this.onSearch();
      },
      submitUpload(file) {
        if (!this.fileList || this.fileList.length === 0) {
          this.$message.error('请先上传Excel附件');
          return;
        }
        this.fjLoading = true;
        this.$q.common.uploadFile({
          data: {
            file: this.fileList[0],
            ...this.$route.query
          }
        }).then((res) => {
          if (res.success) {
            this.$message.success('数据导入中，请稍后');
          } else {
            this.$message.error(res.message);
          }
          this.fjLoading = false;
          this.cancel();
          this.onSearch();
        });
        // this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        this.fileList = [];
        console.log(file, fileList);
      },
      httpRequest(file) {

      },
      handleSuccess(res, file) {
        if (res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.cancel();
        this.onSearch();
      },
      // 验证
      beforeUpload(file) {
        // .xls,.xlsx,.xls.ttt,.xlsx.ttt
        let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
          this.$message.error('请上传后缀名为.xls,.xlsx的附件！');
          return false;
        }
        this.fileList = [];
        this.fileList.push(file);
      },
      beginDate() {
        const self = this
        return {
          disabledDate(time) {
            time.setHours(8);
            if (self.searchForm.endDate) { // 如果结束时间不为空，则小于结束时间
              return new Date(self.searchForm.endDate).getTime() < time.getTime()
            } else {
              // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
            }
          }
        }
      },
      processDate() {
        const self = this
        return {
          disabledDate(time) {
            time.setHours(8);
            if (self.searchForm.startDate) { // 如果开始时间不为空，则结束时间大于开始时间
              return new Date(self.searchForm.startDate).getTime() > time.getTime()
            } else {
              // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
            }
          }
        }
      }
    },
    created() {
      this.tableHeight = window.innerHeight - 282;
    },
    mounted() {
      this.onSearch();
    }
  }
</script>

<style lang="stylus" scoped>
  .search-wrapper
    margin 10px
    padding 8px 10px
    background-color #ffffff

    >>> .el-form-item
      margin-bottom 0

    >>> .el-divider
      margin 10px 0

  .list-wrapper
    margin 10px
    background-color #ffffff

  .table-wrap
    padding 10px

  >>> .el-dialog__header
    background #24c69a
    padding 10px
    position relative
    .el-dialog__title
      font-size 14px
      color #ffffff
    .el-dialog__headerbtn
      top 50%
      transform translate(0,-50%)
      .el-icon
        color #ffffff

  >>> .el-dialog__body
    padding 15px
</style>
